import React, { Component } from 'react';
import { View, Text } from 'react-native';
import utils from '../utils';
import { enabledStyle, disabledStyle } from '../commonStyles';

const statusMap: { [propName: string]: string } = {
    10: 'isWarning',
    11: 'isWarning'
};

const appActionMap: { [propName: string]: boolean } = {
    pay: true
};

interface Props {
    data: {
        productTitle: string;
        hasDate: boolean;
        date: string;
        exchangeAmount: number;
        supplier: string;
        vouchersTitle: string;
        validateStart: string;
        validateEnd: string;
        buyCount: string;
        _disable: boolean;
    };
}

class Index extends Component<Props> {
    public static formatData(data: any) {
        const newData = { ...data };
        // icon
        newData.title = '付费会员';
        newData.iconfont = '\ue613';
        newData.iconColor = '#22cad3';
        // 状态
        newData._orderStatus = statusMap[newData.status];
        // 按钮
        newData.actionInfos = utils.buildActionInfos(newData.appAction, appActionMap);
        // 价格
        newData.currency = (newData.currency || '').trim();
        newData.fixPrice = utils.fixPrice(newData.price, newData.currency);
        newData.fixConvertPrice = utils.fixPrice(newData.convertPrice);

        newData.hasDate = utils.buildDateTime(newData.date);
        return newData;
    }

    public render() {
        const {
            data: {
                productTitle,
                hasDate,
                date,
                exchangeAmount,
                supplier,
                vouchersTitle,
                validateStart,
                validateEnd,
                buyCount,
                _disable
            } = {}
        } = this.props;

        const styles = _disable ? disabledStyle : enabledStyle;

        return (
            <View style={styles.left}>
                <Text style={styles.newOrderTitle} numberOfLines={2}>
                    {productTitle}
                </Text>
                {Boolean(hasDate) && (
                    <Text style={styles.newOrderSubTitle} numberOfLines={1}>
                        {`预约时间  ${date}`}
                    </Text>
                )}
                {Boolean(exchangeAmount) && (
                    <Text numberOfLines={1} style={styles.newOrderSubTitle}>
                        {`兑换金额  ${exchangeAmount}`}
                    </Text>
                )}
                {Boolean(supplier) && (
                    <Text numberOfLines={1} style={styles.newOrderSubTitle}>
                        {`供应商  ${supplier}`}
                    </Text>
                )}
                {Boolean(vouchersTitle) && (
                    <Text numberOfLines={1} style={styles.newOrderSubTitle}>
                        {vouchersTitle}
                    </Text>
                )}
                {Boolean(validateStart && validateEnd) && (
                    <Text numberOfLines={1} style={styles.newOrderSubTitle}>
                        {`${validateStart} 至 ${validateEnd}  有效`}
                    </Text>
                )}
                {Boolean(Number(buyCount)) && (
                    <Text style={styles.newOrderSubTitle} numberOfLines={1}>
                        {`数量：${buyCount}`}
                    </Text>
                )}
            </View>
        );
    }
}

export default Index;
